<template>
  <div class="header" @click="$emit('toggle-collapse')">
    <IconWrapper :name="iconName" class="header-icon" />
    <p class="header-title">{{ counterText }}</p>
    <IconWrapper
      name="chevronDownNeutralIcon"
      class="header-chevron"
      :class="{ 'header-chevron-collapsed': isCollapsed }"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { IconWrapper } from '@/components/common'

const props = defineProps<{
  counterText: string
  isCollapsed: boolean
  hasOnlyFailedVideos: boolean
}>()

const iconName = computed(() => {
  return props.hasOnlyFailedVideos ? 'xErrorRedIcon' : 'uploadVideoProcessingIcon'
})

defineEmits<{
  (e: 'toggle-collapse'): void
}>()
</script>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
  cursor: pointer;
  background: white;

  &-icon {
    width: 20px;
    height: 20px;
  }

  &-title {
    flex: 1;
    font-weight: 700;
    font-size: 16px;
    color: $bodyText;
    margin: 0;
  }

  &-chevron {
    width: 10px;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);

    &-collapsed {
      transform: rotate(-180deg);
    }
  }
}
</style>


